// Same-folder imports with `.ts`: the Node test runner can't resolve `@/`.

/** The one place the callback route's path is written: route, redirect URI and strip guard. */
export const googleCallbackPath = '/auth/callback/google';

interface CallbackLocation {
  pathname: string;
  search: string;
  hash: string;
  href: string;
}

interface CallbackHistory {
  state: unknown;
  replaceState: (state: unknown, unused: string, url: string) => void;
}

let keptCallbackUrl: string | undefined;

/**
 * Google's ID token arrives in the callback URL's fragment. This runs before
 * `posthog.init` (see `PostHogProvider`), so the pageview, autocapture and
 * replay never see the token in `$current_url`: the address loses the
 * fragment and the full URL is kept for `readGoogleCallbackUrl`.
 */
export const stripGoogleCallbackFragment = (
  location: CallbackLocation,
  history: CallbackHistory,
) => {
  if (location.pathname !== googleCallbackPath || !location.hash) {
    return;
  }

  keptCallbackUrl = location.href;
  history.replaceState(
    history.state,
    '',
    `${location.pathname}${location.search}`,
  );
};

/** The callback URL with its fragment, as Google sent it. */
export const readGoogleCallbackUrl = (currentHref: string) =>
  keptCallbackUrl ?? currentHref;
